export default __webpack_public_path__ + "images/logoSnowFox.6af4aae84d349cd63b5918405d69bf27.svg"